module.exports = function(value1, value2) {
    return value1 + value2;
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/hbHelpers/add.js
// module id = 5
// module chunks = 0